import { API_CONFIG, buildApiUrl } from './config';

class PickupAPI {
  static pickupBaseURL = process.env.REACT_APP_PICKUP_API_BASE_URL || API_CONFIG.baseURL;

  static buildPickupUrl(endpoint, params = {}) {
    let url = `${PickupAPI.pickupBaseURL}${endpoint}`;
    Object.keys(params).forEach((key) => {
      url = url.replace(`:${key}`, params[key]);
    });
    return url;
  }

  static buildHeaders({ adminId, username } = {}) {
    return {
      'Content-Type': 'application/json',
      ...(adminId ? { 'x-admin-id': adminId } : {}),
      ...(username ? { 'x-username': username } : {}),
    };
  }

  static async pickupApiCall(
    endpoint,
    { method = 'GET', params = {}, query = {}, adminId, username, body } = {}
  ) {
    const urlObj = new URL(PickupAPI.buildPickupUrl(endpoint, params));

    Object.entries(query || {}).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        urlObj.searchParams.set(key, value.toString());
      }
    });

    const response = await fetch(urlObj.toString(), {
      method,
      headers: PickupAPI.buildHeaders({ adminId, username }),
      ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
    });

    const text = await response.text().catch(() => '');
    let result = {};
    if (text) {
      try {
        result = JSON.parse(text);
      } catch {
        result = { message: text };
      }
    }

    if (!response.ok) {
      throw new Error(
        result.message || result.error || `HTTP ${response.status}: ${response.statusText || 'Request failed'}`
      );
    }

    return result;
  }

  // ==================== PICKUP ROSTERS ====================
  
  static async getRostersByCoach(coachId) {
    try {
      const result = await PickupAPI.pickupApiCall(API_CONFIG.endpoints.rosters.getByCoach, {
        params: { coachId },
      });
      return result.data || [];
    } catch (error) {
      console.error('❌ Error getting rosters by coach:', error);
      throw error;
    }
  }

  static async getRosterById(rosterId) {
    try {
      const result = await PickupAPI.pickupApiCall(API_CONFIG.endpoints.pickup.rosters.getById, {
        params: { id: rosterId },
      });
      return result.data;
    } catch (error) {
      console.error('❌ Error getting roster by ID:', error);
      throw error;
    }
  }
}

export default PickupAPI;
